import { Controller } from "@hotwired/stimulus"

// "✨ Write a description": asks the server for a short AI description of the dish typed in the form.
export default class extends Controller {
  static targets = ["button", "status"]
  static values = { url: String, sectionId: Number }

  async write() {
    const form = this.element.closest("form")
    const name = form.querySelector("[name='item[name]']")
    const description = form.querySelector("[name='item[description]']")
    if (!name.value.trim()) {
      this.statusTarget.textContent = "Type the dish name first."
      name.focus()
      return
    }

    const label = this.buttonTarget.textContent
    this.buttonTarget.disabled = true
    this.buttonTarget.textContent = "Writing…"
    this.statusTarget.textContent = ""
    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content
        },
        body: JSON.stringify({ name: name.value, section_id: this.sectionIdValue })
      })
      const data = await response.json().catch(() => ({}))
      if (response.ok && data.description) {
        description.value = data.description
        description.focus()
        this.statusTarget.textContent = "Check it and edit as you like."
      } else {
        this.statusTarget.textContent = data.error || "Couldn't write a description right now."
      }
    } catch {
      this.statusTarget.textContent = "Couldn't reach the server. Check your connection."
    } finally {
      this.buttonTarget.disabled = false
      this.buttonTarget.textContent = label
    }
  }
}
